import { FASTAPI_BASE_URL } from "../config";

async function handle(res) {
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const detail = data?.detail;
    const message =
      (typeof detail === "string" ? detail : detail?.message) ||
      data?.message ||
      `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data;
}

export async function apiGetChapterLearningCatalog(
  fetchWithAuth,
  { chapterId, userId, languageId = 1, lang = "en" } = {}
) {
  const qs = new URLSearchParams({
    user_id: String(userId || ""),
    language_id: String(languageId || 1),
    lang: String(lang || "en"),
  });
  return handle(
    await fetchWithAuth(
      `${FASTAPI_BASE_URL}/chapter-learning/${encodeURIComponent(chapterId)}/catalog?${qs.toString()}`
    )
  );
}

// Separate, backend-authorized authored package feed. Never send user_id as identity.
export async function apiGetAuthoredChapterPackage(fetchWithAuth, chapterId) {
  const response = await fetchWithAuth(
    `${FASTAPI_BASE_URL}/chapter-learning/${encodeURIComponent(chapterId)}/authored-package`
  );
  if ([403, 404, 503].includes(response.status)) return null;
  return handle(response);
}
